module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hideList),
      expression: "hideList"
    }],
    staticClass: "simple-color-picker"
  }, [_c('div', {
    staticClass: "picker-header",
    on: {
      "click": _vm.toggleList
    }
  }, [(_vm.label) ? _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _c('div', {
    staticClass: "color-value",
    style: ('background-color: ' + _vm.colorValue)
  })]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "colors-list-container"
  }, [_c('div', {
    staticClass: "colors-list"
  }, _vm._l((_vm.viewColors), function(color, i) {
    return _c('div', {
      on: {
        "click": _vm.hideList
      }
    }, [_c('label', {
      class: ((_vm.colorValue == color) ? 'active' : ''),
      style: ('background-color: ' + color),
      attrs: {
        "for": 'simple-color-input-' + _vm.id + '-' + i
      }
    }), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.colorValue),
        expression: "colorValue"
      }],
      attrs: {
        "id": 'simple-color-input-' + _vm.id + '-' + i,
        "type": "radio",
        "name": "color"
      },
      domProps: {
        "value": color,
        "checked": _vm._q(_vm.colorValue, color)
      },
      on: {
        "change": [function($event) {
          _vm.colorValue = color
        }, _vm.changeValue]
      }
    })])
  }))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0656996d","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SimpleColorPicker.vue
// module id = 1029
// module chunks = 0